import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderReportPrintParams from "./OrderRequestsModel/OrderReportPrintParams"

export default function SendEmailObservable(params: OrderReportPrintParams): Observable<any> {
  const requestBody: string = JSON.stringify({
    SendToEmail: true,
    EmailAddress: params.EmailAddress,
    TestDetailIDs: params.TestDetailIDs,
    TestDetailClinicalIDs: params.TestDetailClinicalIDs,
    PersonID: params.PersonID,
    VendorID: params.VendorID,
    XMLFile: params.XMLFile,
    ClientDetails: {
      // TODO: ContactID: VALUESTORAGE.CONTACT_ID
    },
  })

  return ObservableFromFetch<any>("WorkforceReport/AuthorizationFormReport", requestBody)
}